/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {HeaderComponent as ɵb} from './src/app/urbisoft-main-structure/components/header/header.component';
export {SidenavComponent as ɵa} from './src/app/urbisoft-main-structure/components/sidenav/sidenav.component';